import { GlobalWorkerOptions } from "pdfjs-dist";

/** Public path to the pdf.js worker copied by Carrie's postinstall script. */
export const PDFJS_WORKER_SRC = "/pdf.worker.min.mjs";

/**
 * Ensure pdf.js uses a real Web Worker instead of the main-thread fake worker.
 *
 * Ask Puntt's AssetViewerPane / FilePreviewBlock import `getDocument` directly
 * and historically never set `workerSrc`. Without this, every PDF parse/render
 * blocks the UI thread. Idempotent — safe to call from multiple entry points.
 */
export function ensurePdfjsWorker(): string {
  if (GlobalWorkerOptions.workerSrc !== PDFJS_WORKER_SRC) {
    GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
  }
  // DevTools / Performance panel: confirm real-worker path (not fake worker).
  if (typeof performance !== "undefined" && performance.mark) {
    performance.mark("ask_puntt_pdf_worker_mode", {
      detail: { workerSrc: GlobalWorkerOptions.workerSrc, mode: "real" },
    });
  }
  return GlobalWorkerOptions.workerSrc;
}

/** True when a non-empty workerSrc is configured (real worker path). */
export function isPdfjsWorkerConfigured(): boolean {
  return (
    typeof GlobalWorkerOptions.workerSrc === "string" &&
    GlobalWorkerOptions.workerSrc.length > 0
  );
}
